import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.5 16V15L8.08361 13.9377C6.45719 12.7179 5.5 10.8035 5.5 8.77048V7.96735C5.5 5.60918 7.03802 3.52676 9.29191 2.83326V2.83326C11.0565 2.29031 12.9435 2.29031 14.7081 2.83326V2.83326C16.962 3.52676 18.5 5.60918 18.5 7.96735V8.77048C18.5 10.8035 17.5428 12.7179 15.9164 13.9377L14.5 15V16"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
        <path
            d="M9.5 18.5H14.5M13.5 21H10.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
